if (!customElements.get('mobile-dock')) {
  customElements.define(
    'mobile-dock',
    class MobileDock extends HTMLElement {
      constructor() {
        super();
        this.section = this.closest('.section-mobile-dock');
      }

      connectedCallback() {
        const header = document.querySelector('.section-header');
        const stickyHeader = document.querySelector('sticky-header');
        if (header === null) {
          this.section.classList.add('active');
        } else if (stickyHeader === null) {
          this.scrollY = parseInt(header.getBoundingClientRect().bottom);
          this.onScrollHandler = this.onScroll.bind(this);
          window.addEventListener('scroll', this.onScrollHandler, false);
        }

        setTimeout(() => document.documentElement.style.setProperty('--mobile-dock-height', `${this.offsetHeight}px`));
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollHandler);
      }

      onScroll() {
        this.section.classList.toggle('active', window.scrollY >= this.scrollY);
      }
    }
  );
}